import React, { useEffect, useState } from "react";
import TabsHeader from "../components/TabsHeader";
import Place from "@mui/icons-material/Place";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";

import MapGoogle from "../components/mapsGoogle/MapGoogle";
import useMaps from "../hooks/useMaps";
import useWhereBuy from "../hooks/useWhereBuy";
// img intro
import imgIntro from "../assets/images/nodinamic/donde-comprar.jpg";
import useProduct from "../hooks/useProduct";
import useCorralonFilter from "../hooks/useCorralonesFilter";

const WhereBuy = () => {
  const [activoBuy, setActivoBuy] = useState(false);
  const [corralon, setCorralon] = useState(null);
  const [corralones, setCorralones] = useState(null);
  const [corralonesPais, setCorralonesPais] = useState({});
  const [paisFiltroCorralon, setPaisFiltroCorralon] = useState(null);
  const [provinciasCorralon, setProvinciasCorralon] = useState({});
  const [provinciasCorralonUnico, setProvinciasCorralonUnico] = useState({});
  const [localidadCorralon, setLocalidadCorralon] = useState({});
  const [localidadCorralonUnico, setLocalidadCorralonUnico] = useState({});
  const [clean, setClean] = useState(null);
  const [disabledSelect, setDisabledSelect] = useState(null);
  const {
    markersWhereBuy,
    warehouseList,
    centerWhereBuy,
    setCenterWhereBuy,
    corralonesAll,
  } = useMaps();
  const {
    countriesFilter,
    provincias,
    provincia,
    setProvincia,
    localidades,
    setLocalidades,
    corralonesConProducto,
    searchLocalidades,
    setCorralonesConProductos,
    searchCorralonConProd,
    searchCorralonConProv,
  } = useWhereBuy();
  const { products } = useProduct();

  const { corralonesFilter } = useCorralonFilter();

  /* Funcion que recibe el rango de dias y lo calcula */
  // function subtractDays(date, days) {
  //   date.setDate(date.getDate() - days);

  //   return date;
  // }
  useEffect(() => {
    setActivoBuy(true);
    document.title = "Dónde comprar productos Tensolite";
    setCorralones({ corralonesAll });
  }, []);

  const filtrarMapa = (corralonesConProducto) => {
    const newMarkers = [];
    corralonesConProducto?.forEach((p) => {
      warehouseList.find((w) => w.id === p.id) &&
        newMarkers.push({
          id: warehouseList.find((w) => w.id === p.id).id,
          position: {
            lat: Number(warehouseList.find((w) => w.id === p.id).lat),
            lng: Number(warehouseList.find((w) => w.id === p.id).long),
          },
        });
    });
    return newMarkers?.length !== 0 ? newMarkers : null;
  };

  useEffect(() => {
    /* Filtro para corralones con actividad en los ultimos 120 dias */
    // const dateFirst = new Date()
    // const since = subtractDays(dateFirst, 120).toISOString().split('T')[0].split('-')
    // const c = corralonesConProducto ? (corralonesConProducto?.filter((co) =>
    //   co?.updated_at?.split(' ')[0].split('-')?.[0] >= since[0] &&
    //   co?.updated_at?.split(' ')[0].split('-')?.[1] === since[1] ?
    //   (co?.updated_at?.split(' ')[0].split('-')?.[2] >= since[2] && co)
    //   :
    //   (co?.updated_at?.split(' ')[0].split('-')?.[1] > since[1]
    //   && co)
    //   )) : ''
    // const newCorralones = c
    //   ? c?.filter(
    //       (c) => Number(c?.provincia_id) === Number(provincia)
    //     )
    //   : corralonesConProducto ? corralonesConProducto?.filter(
    //     (c) => Number(c?.provincia_id) === Number(provincia)
    //   ) : '';

    const newCorralones = corralonesConProducto
      ? disabledSelect
        ? corralonesConProducto
        : corralonesConProducto?.filter(
            (c) => Number(c?.provincia_id) === Number(provincia)
          )
      : "";
    setCorralones(newCorralones);
  }, [corralonesConProducto]);

  /* Funcion para el zoom en el mapa */
  useEffect(() => {
    if(corralonesConProducto){
      let [lat, lng] = corralonesConProducto[0]?.coordenadas?.split(",");
      setCenterWhereBuy({ lat: parseFloat(lat), lng: parseFloat(lng) });
    }
  }, [corralonesConProducto]);

  /* Funcion para paises con corralon */
  useEffect(() => {
    const newCorralonesPais = corralonesAll
      ? corralonesAll
          ?.filter((c) => c.pais_id && { pais: c?.pais_id })
          ?.map((c) => {
            return { pais: c.pais_id };
          })
      : "";
    // eslint-disable-next-line no-unused-expressions
    setCorralonesPais(newCorralonesPais);
  }, [corralonesAll]);

  useEffect(() => {
    const newCorralon = countriesFilter?.filter(
      (pais) =>
        corralonesPais?.find(
          (c) => String(pais.country_phone_code) === String(c.pais)
        ) && pais
    );
    setPaisFiltroCorralon(newCorralon);
  }, [corralonesPais]);

  /* Provincias con corralon */
  useEffect(() => {
    const newCorralonesProv = corralonesAll
      ? corralonesAll
          .filter((c) => c.provincia_id)
          ?.map((p) => {
            return p.provincia_id;
          })
      : "";
    setProvinciasCorralon(newCorralonesProv);
  }, [corralonesAll]);

  useEffect(() => {
    const unicos =
      provinciasCorralon?.length > 0
        ? provinciasCorralon?.filter((valor, indice) => {
            return provinciasCorralon?.indexOf(valor) === indice;
          })
        : "";
    const newCorralon = provincias?.filter(
      (prov) => unicos?.find((c) => String(prov.id) === String(c)) && prov
    );
    setProvinciasCorralonUnico(newCorralon);
  }, [provinciasCorralon]);

  /* Localidades con corralon */
  useEffect(() => {
    const newCorralonesLoc = newArray
      ? newArray
          .filter((c) => c.localidad_id)
          ?.map((p) => {
            return p.localidad_id;
          })
      : "";
    setLocalidadCorralon(newCorralonesLoc);
  }, [corralones]);

  useEffect(() => {
      const unicos =
        localidadCorralon?.length > 0
          ? localidadCorralon?.filter((valor, indice) => {
              return localidadCorralon?.indexOf(valor) === indice;
            })
          : null;

    if (unicos?.length > 0) {
      const newCorralon =
        localidades?.length > 0
          ? localidades?.filter(
              (loc) => unicos?.find((c) => String(loc?.id) === String(c)) ? loc : ''
            )
          : "";
            setLocalidadCorralonUnico(newCorralon);

    } else {
      setLocalidadCorralonUnico({});
    }
  }, [localidades, localidadCorralon]);

  const productsOptions = products
    ?.filter((item) => item.deleted !== true && item.type === "productoLinea")
    .map((item) => {
      return { label: item.title, value: item.title };
    });

  const handleChangeProv = (e) => {
      searchLocalidades(e.target.value);
      searchCorralonConProv(e.target.value);
      setClean(null);
  };

  /* Funcion para zoom segun el pais */
  const handleChangeCountry = (e) => {
    if (e.target.value === "0") {
      setDisabledSelect(false);
      setCenterWhereBuy({
        lat: -31.417,
        lng: -64.183,
      });
      setCorralones(null);
    } else if (e.target.value !== "0") {
      setClean(0);
      setDisabledSelect(true);
      setCorralonesConProductos(
        corralonesAll.filter(
          (c) => String(c.pais_id) === String(e.target.value)
        )
      );
    }
    setClean(null);
  };

  /* Funcion para limpiar campos con el boton */
  const cleanValue = (e) => {
    e.preventDefault();
    setCorralones(null);
    setLocalidades(null);
    setDisabledSelect(null);
    setCenterWhereBuy({
      lat: -31.417,
      lng: -64.183,
    });
    setClean(0);
  };

  let newArray = [];

    if (corralones && Array.isArray(corralones)) {
      if (corralonesFilter && Array.isArray(corralonesFilter[0]?.corralones)) {
        newArray = corralones.filter((corralon) =>
          !corralonesFilter[0].corralones?.some((c) => c.id === corralon.id)
        );
      }
    }

  return (
    <>
      {/* INTRO CABECERA */}
      <div id="where-buy" className="bg-fullpage">
        <img src={imgIntro} alt="" />

        <div className="container">
          <header id="contactanos">
            <h1>Queremos estar más cerca tuyo</h1>
            <p>
              Puedes comprar nuestros Productos de Línea en el corralón más
              cercano a tu casa
            </p>
          </header>
          <TabsHeader activoBuy={activoBuy} />
        </div>
      </div>

      {/* Probando */}
      {/* <WhereToBuyContext.Provider value={getWarehouseList()} > */}
      <section className="view">
        <section className="">
          <div className="card-map ">
            {markersWhereBuy && (
              <MapGoogle
                markers={corralones ? filtrarMapa(newArray) : markersWhereBuy}
                center={centerWhereBuy}
                zoom={corralones ? 10 : 5}
                data={warehouseList}
                corralon={true}
                setCorralon={setCorralon}
              />
            )}
          </div>{" "}
        </section>
        {/* </WhereToBuyContext.Provider> */}

        <section
          id="institucional__dondecomprar"
          className="display container flex-no-wrap"
        >
          <div className="grid-dondecomprar">
            <div className="style-donde-comprar-izquierda">
              <header>
                <h2 className="id-section-dondecomprar">Nuestras sucursales</h2>
              </header>

              <div className="d-flex info-ubicacion">
                <div className="col-xs-12 col-sm-6 margin-right">
                  <p className="titulo-sucursal">
                    <Place
                      aria-label="¿Dónde comprar?"
                      titleAccess="¿dónde comprar?"
                      htmlColor="#00aff1"
                    />{" "}
                    <span>Tucumán</span>
                  </p>
                  <small>
                    Ruta Nac. 9 km 1298
                    <br />
                    4101 Los Pocitos, Tucumán{" "}
                  </small>
                </div>
                <div className="col-xs-12 col-sm-6">
                  <p className="titulo-sucursal">
                    <Place
                      aria-label="¿Dónde comprar?"
                      titleAccess="¿Dónde comprar?"
                      htmlColor="#00aff1"
                    />{" "}
                    <span>Córdoba</span>
                  </p>
                  <small>
                    Ruta Nac. 9 km 666
                    <br />
                    5960 Río Segundo, Córdoba{" "}
                  </small>
                </div>
              </div>
            </div>
            {/* Seccion nuestros productos */}
            <div className="info-nuestros-productos">
              <header>
                <h2 className="id-section-dondecomprar">DÓNDE COMPRAR</h2>
              </header>

              {/* Formulario */}
              <form id="wherebuy" className="settings__form-styles">
                {/* <div className="mb-2 col-100">
                  <select
                    onChange={(e) => setObjSearch({ producto: e.target.value })}
                  >
                    <option selected disabled>
                      ¿Qué estas buscando?
                    </option>
                    {productsOptions.map((prod, index) => (
                      <option key={index} value={prod.value}>
                        {prod.label}
                      </option>
                    ))}
                  </select>
                </div> */}
                <div className="mb-2 col-100">
                  <select
                    value={clean}
                    onChange={handleChangeCountry}
                    id="select_country"
                  >
                    <option value="0" selected>
                      Argentina
                    </option>
                    {paisFiltroCorralon?.map((pais) => (
                      <option value={pais.country_phone_code}>
                        {" "}
                        {pais.country_name}{" "}
                      </option>
                    ))}
                  </select>
                </div>
                <div id="select_prov2" className="mb-2 col-100">
                  <select
                    value={clean}
                    onChange={handleChangeProv}
                    id="select_prov"
                    disabled={disabledSelect}
                  >
                    <option value="0" selected>
                      Provincia
                    </option>
                    {provinciasCorralonUnico?.length > 0
                      ? provinciasCorralonUnico?.map((provincia) => (
                          <option value={provincia.id}>
                            {" "}
                            {provincia.nombre}{" "}
                          </option>
                        ))
                      : ""}
                  </select>
                </div>
                <div className="mb-2 col-100">
                  <select
                    onChange={(e) => {
                      if (e.target.value !== "Localidades") {
                        return searchCorralonConProd(e.target.value);
                      }
                    }}
                    id="select_loc"
                    value={localidadCorralon ?? clean}
                    disabled={disabledSelect}
                  >
                    <option value="0" selected>
                      Localidades
                    </option>
                    {localidadCorralonUnico?.length > 0
                      && localidadCorralonUnico?.map((localidad) => (
                          <option value={localidad?.id}>
                            {" "}
                            {localidad?.nombre}{" "}
                          </option>
                        ))
                      }
                  </select>
                </div>
                <div className="col-12 mt-4">
                  <button
                    onClick={cleanValue}
                    className="settings_button-pleno bg-p-secondary mb-4 float-end button_mobile d-flex justify-content-center"
                  >
                    LIMPIAR
                  </button>
                </div>
              </form>
              {/* <Link to="" className="block link-tienda-sm">
              <StoreIcon htmlColor="#00aff1" />
              Visita nuestra tienda online
            </Link> */}
            </div>

            {/* Seccion Lista de corralones */}
            <div>
              <h2 className="id-section-contacto dondecomprar__result-title">
                {/* {corralonesConProducto?.length !== ? 'No se encontraron corralones' : `Corralones encontrados (${corralonesConProducto?.length})`}  */}
                {corralones === null
                  ? `Corralones encontrados (0)`
                  : corralones?.length === 0
                  ? "No se encontraron corralones"
                  : `Corralones encontrados (${newArray?.length})`}
              </h2>

              <ul className="md:w-1/2 rounded-lg settings__form-styles list-styles">
                {newArray?.length !== 0 &&
                  newArray?.map((corralon) => (
                    <>
                      <li
                        className="col-12 dondecomprar_point"
                        onClick={() => setCorralon(corralon)}
                      >
                        <h3>{corralon?.nombre}</h3>

                        <div className="mt-3 dondecomprar__result">
                          <p>
                            <Place
                              aria-label="¿Dónde comprar?"
                              titleAccess="¿dónde Comprar?"
                              htmlColor="#00aff1"
                            />{" "}
                            <a
                              href={`http://maps.google.com/?q=${corralon?.lat},${corralon?.long}`}
                              target="_blank"
                              rel="noreferrer"
                            >
                              {" "}
                              {corralon?.direccion}
                            </a>
                          </p>
                          <p>
                            <PhoneIcon
                              aria-label="¿Dónde comprar?"
                              titleAccess="¿dónde Comprar?"
                              htmlColor="#00aff1"
                            />{" "}
                            <a
                              href={`tel:${corralon?.telefono}`}
                              target="_blank"
                              rel="noreferrer"
                              title={`Marcar al ${corralon?.telefono}`}
                            >
                              {corralon?.telefono}
                            </a>
                          </p>
                          <p>
                            <EmailIcon
                              aria-label="¿Dónde comprar?"
                              titleAccess="¿dónde Comprar?"
                              htmlColor="#00aff1"
                            />{" "}
                            <a
                              href={`mailto:${corralon?.email}`}
                              target="_blank"
                              rel="noreferrer"
                              title={`Escribir a ${corralon?.email}`}
                            >
                              {corralon?.email}
                            </a>
                          </p>
                        </div>

                        <hr />
                      </li>
                    </>
                  ))}
              </ul>
            </div>
          </div>
        </section>
      </section>
    </>
  );
};

export default WhereBuy;
